<template>
  <div class="about">
    <h1>A site for events do berrer the world.</h1>
  </div>
</template>
